import type {ComponentRepository} from '../../repository/ComponentRepository'
// eslint-disable-next-line wix-editor/no-internal-import
import {type EditorElementLayout, LAYOUT} from '@wix/component-protocol/schema'
import type {ManifestFeatureComponentStageBehavior, Pointer} from '@wix/document-services-types'

export class LayoutBuilder {
    private readonly DEFAULT_LAYOUT: EditorElementLayout = {
        resizeDirection: LAYOUT.RESIZE_DIRECTION.horizontalAndVertical,
        disablePositioning: false,
        disableRotation: false,
        disableStretching: false,
        disableDuplication: false
    }

    private layout: EditorElementLayout = this.DEFAULT_LAYOUT

    constructor(private readonly componentRepository: ComponentRepository) {}

    private setResizeDirection(resizable?: ManifestFeatureComponentStageBehavior['resizable']) {
        if (!resizable) {
            this.layout.resizeDirection = LAYOUT.RESIZE_DIRECTION.none
        }
        return this
    }

    // By default, all widgets are duplicatable in Blocks
    private setDisableDuplication(duplicatable: ManifestFeatureComponentStageBehavior['duplicatable'] = true) {
        if (!duplicatable) {
            this.layout.disableDuplication = true
        }
        return this
    }

    buildRootComponentLayoutManifest(componentPointer: Pointer) {
        const componentManifest = this.componentRepository.getManifestData(componentPointer)
        const {behavior} = componentManifest || {}

        return this.setResizeDirection(behavior?.resizable).setDisableDuplication(behavior?.duplicatable).layout
    }
}
